import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import AccountingNavigation from './components/AccountingNavigation'

import AccountingRoutes from './routes'

const Accounting = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation
        notificationsComponent={<Notifications />}
        searchComponent={<DashboardSearch />}
      />

      <MainNavigation minimized nestedNavigation={<AccountingNavigation />} />

      <MainContent nestedNavigation offset={{ top: TopBar.topBarHeight }}>
        <AccountingRoutes />
      </MainContent>
    </>
  )
}

export default Accounting
